import React, { useEffect, useState } from "react";
import axios from "../../axiosInstance";
import "./RunningHeader.css";

const RunningHeader = () => {
  const [groupedItems, setGroupedItems] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch items using Axios
    const fetchItems = async () => {
      try {
        const response = await axios.get("/api/admin/items/readall");
        const items = response.data;

        // Group items by category
        const grouped = items.reduce((acc, item) => {
          if (!acc[item.category]) {
            acc[item.category] = [];
          }
          acc[item.category].push(item);
          return acc;
        }, {});

        setGroupedItems(grouped);
        setLoading(false);
      } catch (err) {
        setError(err.message || "Failed to fetch items");
        setLoading(false);
      }
    };

    fetchItems();
  }, []);

  if (loading) {
    return <div className="running-header">Loading...</div>;
  }

  if (error) {
    return <div className="running-header">Error: {error}</div>;
  }

  return (
    <div className="running-header">
      <div className="marquee">
  {Object.keys(groupedItems).map((category) => (
    <div key={category} className="category-group">
      <strong className="category-title">{category}</strong>:{" "}
      {groupedItems[category].map((item) => (
        <span key={item._id} className="item">
          {item.name} &nbsp;- RS: {item.price},&nbsp;
        </span>
      ))}
    </div>
  ))}
</div>

    </div>
  );
};

export default RunningHeader;
